import React from 'react';
import { FaFileLines } from 'react-icons/fa6';
import './ProtocolAttachments.css';
import { useResusContext } from '../Resus/ResusContext';
import { getHospitalData } from './PerHospitalResusConfig';

interface Attachment {
  name: string;
  file: string;
}

interface ProtocolAttachmentsProps {
  name: string;
  attachments: Attachment[]; // Use attachments array
  hideTitle?: boolean;
}

const ProtocolAttachments: React.FC<ProtocolAttachmentsProps> = ({
  name,
  attachments, // Destructure attachments
  hideTitle = false
}) => {  
  const { hospital } = useResusContext();
  const baseUrl = getHospitalData(hospital).protocols_base_folder;

  return (
    <div className="protocol-item">
      {!hideTitle && <div className="protocol-name">{name}</div>}
      <div className="protocol-files">
        {/* Map over the attachments array */}
        {attachments.map((attachment, index) => (
          <a 
            key={index} // Use index as key for simplicity, consider a more stable key if possible
            href={`${baseUrl}${attachment.file}`}
            target="_blank"
            rel="noopener noreferrer"
            className="file-link"
          >
            <div className="file-box">
              <span className="file-text">{attachment.name}</span> {/* Use attachment name */}
              <FaFileLines className="file-icon" />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ProtocolAttachments;
